// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupAddressDto
 */
export interface IExpressSetupAddressDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupAddressDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAddressDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAddressDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAddressDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupAddressDto
     */
    zipcode: string;
}

/**
 * Check if a given object implements the IExpressSetupAddressDto interface.
 */
export function instanceOfIExpressSetupAddressDto(value: object): value is IExpressSetupAddressDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    return true;
}

export function IExpressSetupAddressDtoFromJSON(json: any): IExpressSetupAddressDto {
    return IExpressSetupAddressDtoFromJSONTyped(json, false);
}

export function IExpressSetupAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
    };
}

export function IExpressSetupAddressDtoToJSON(json: any): IExpressSetupAddressDto {
    return IExpressSetupAddressDtoToJSONTyped(json, false);
}

export function IExpressSetupAddressDtoToJSONTyped(value?: IExpressSetupAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
    };
}

